import React, { useRef } from 'react';
import * as S from './styles';
// import Events from '../../Events';
function Home1() {
  const divRef = useRef<HTMLDivElement | null>(null); // Especificando que o ref pode ser de um HTMLDivElement ou null

  const scrollToDiv = () => {
    divRef.current && divRef.current.scrollIntoView({ behavior: 'smooth' }); // Scroll suave até a div
  };

  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <div>
            <h3>Eventos</h3>
          </div>
          <p>
            Participe de nossos próximos eventos e aprofunde seu conhecimento em
            psicanálise. <br />
            Descubra palestras, seminários, minicursos promovidos pelo
            Travessias.
          </p>
          <button onClick={scrollToDiv}> Confira os eventos</button>
        </S.TextDiv>
      </S.Section>
      <p ref={divRef} />
    </S.Main>
  );
}

export default Home1;
